import * as Yup from 'yup';
import { getValidationRules } from '../../utils/validation';
import { Validation } from './RequestQuoteWizard.types';
// @ts-ignore
import * as content from './content.json';

export const validation: Validation[] = [
  {
    STEP_1: Yup.object().shape({
      ...getValidationRules(content.stepOne)
    }),
    STEP_2: Yup.object().shape({
      ...getValidationRules(content.stepTwo)
    })
  },
  {
    STEP_1: Yup.object().shape({
      ...getValidationRules(content.stepOneBattery)
    }),
    STEP_2: Yup.object().shape({
      ...getValidationRules(content.stepTwo)
    })
  }
];
